import React from "react";
import PropTypes from "prop-types";
import "./LabeledValue.scss";

/**
 * LabeledValue.
 */
const LabeledValue = ({ label, value, title = value, ...other }) => {
  return (
    <div className="labeled-value-container">
      <label className="label">{label}</label>
      <div title={title} className="value" {...other}>
        {value}
      </div>
    </div>
  );
};

LabeledValue.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};
export default LabeledValue;
